import { ModelType, TireSize, ProviderLocation } from 'app/profile/models/loaner-wheel-inventory';
import { SupplierTaskStep } from 'app/profile/models/suppliertasks.model';

export interface SupplierTasksState {
  supplierTaskStep: SupplierTaskStep;
}

export const initialState: SupplierTasksState = {
  supplierTaskStep: null
};
